<div class="oqs-question-group form-group ng-animate oqs-animate-fade-right" ng-hide="oqsQuestionControl.question.hidden"
     ng-class="{'required': oqsQuestionControl.question.definition.attributes.required=='true', 'has-error': (oqsQuestionControl.question.answer == null || oqsQuestionControl.question.answer.length < 1) && oqsQuestionControl.question.definition.attributes.required=='true' && oqsQuestionControl.validationActive}"
     title="{{{true: 'Required'}[oqsQuestionControl.question.definition.attributes.required=='true']}}">
  <label class="oqs-question-label control-label col-sm-4">
    <span ng-bind="oqsQuestionControl.question.definition.description"></span>
    <span ng-if="oqsQuestionControl.question.definition.helpInfo"  class="fa fa-question-circle oqs-popover-toggle"
          uib-popover-html="oqsQuestionControl.question.definition.helpInfo | trustAsHtml" popover-class="oqs-popover" popover-placement="top"
          popover-trigger="mouseenter click" popover-append-to-body="true"></span>
  </label>
  <div class="oqs-question-control col-sm-8" ng-switch="oqsQuestionControl.question.definition.inputControl" ng-form="oqsQuestionControlForm">
    <input ng-switch-when="TEXT"
           type="text" class="form-control" ng-model="oqsQuestionControl.question.answer"
           name="oqsField"
           ng-required="oqsQuestionControl.isFormElementRequired()"
           ng-pattern="oqsQuestionControl.question.definition.attributes.pattern"
           ng-attr-autofocus="{{oqsQuestionControl.question.definition.attributes.flag=='name'}}"
           ng-maxlength=100
           maxlength="100"
           ng-model-options="{ debounce: 100 }"
      />

    <input ng-switch-when="POSTALCODE"
           type="text" class="form-control" ng-model="oqsQuestionControl.question.answer"
           name="oqsField"
           ng-required="oqsQuestionControl.isFormElementRequired()"
           ng-pattern="oqsQuestionControl.question.definition.attributes.pattern"
           ng-change="oqsQuestionControl.updatePostalCodeAnswer()"
      />

    <div ng-switch-when="DATE"
         class="form-control-container select-inline">
      <select ng-change="oqsQuestionControl.updateDateAnswer()" ng-model="oqsQuestionControl.day" ng-options="day as day for day in oqsQuestionControl.dayOptions()" ng-required="oqsQuestionControl.isFormElementRequired()" class="form-control"></select>
      <select ng-change="oqsQuestionControl.updateDateAnswer()" ng-model="oqsQuestionControl.month" ng-options="month as month for month in oqsQuestionControl.monthOptions()" ng-required="oqsQuestionControl.isFormElementRequired()" class="form-control"></select>
      <select ng-change="oqsQuestionControl.updateDateAnswer()" ng-model="oqsQuestionControl.year" ng-options="year as year for year in oqsQuestionControl.yearOptions(100)" ng-required="oqsQuestionControl.isFormElementRequired()" class="form-control"></select>
    </div>

    <div ng-switch-when="SLIDER"
         class="slider">
      <div slider ng-model="oqsQuestionControl.question.answer"
           start="{{ 1 * oqsQuestionControl.question.definition.attributes.min}}"
           end="{{ 1 * oqsQuestionControl.question.definition.attributes.max}}"
           step="{{ 1 * oqsQuestionControl.question.definition.attributes.step}}">
      </div>
      <div ng-if="oqsQuestionControl.question.definition.dataType=='CURRENCY'" class="slider-value"
           ng-bind="oqsQuestionControl.question.answer | currency"></div>
      <div ng-if="oqsQuestionControl.question.definition.dataType!='CURRENCY'" class="slider-value"
           ng-bind="oqsQuestionControl.question.answer"></div>
    </div>

    <div ng-switch-when="COMBOSLIDER"
         class="form-control-container" >
      <div class="comboslider-inputfield pull-left"
           ng-class="{'has-error': !oqsQuestionControl.isInputFieldWithinComboSliderRange()}">
        <input type="number"
               class="form-control"
               min="{{ 1 * oqsQuestionControl.question.definition.attributes.min}}"
               max="{{ 1 * oqsQuestionControl.question.definition.attributes.max}}"
               step="{{ 1 * oqsQuestionControl.question.definition.attributes.step }}"
               ng-model="oqsQuestionControl.comboSliderInputFieldValue"
               ng-change="oqsQuestionControl.onComboSliderInputFieldChange()"
               uib-popover="{{ oqsQuestionControl.getComboSliderPopupMessage() }}"
               popover-trigger="none"
               popover-class="oqs-popover"
               popover-placement="top"
               popover-is-open="!oqsQuestionControl.isInputFieldWithinComboSliderRange()"
               ng-required="!oqsQuestionControl.question.hidden"
          />
      </div>
      <div class="comboslider">
        <div slider ng-model="oqsQuestionControl.question.answer"
             start="{{ 1 * oqsQuestionControl.question.definition.attributes.min}}"
             end="{{ 1 * oqsQuestionControl.question.definition.attributes.max}}"
             step="{{ 1 * oqsQuestionControl.question.definition.attributes.step}}">
        </div>
      </div>
    </div>

    <div ng-switch-when="RADIO">
      <div class="oqs-radio-buttons btn-group btn-group-justified">
        <label class="btn btn-default" ng-repeat="option in oqsQuestionControl.question.definition.optionList"
               ng-model="oqsQuestionControl.question.answer"
               uib-btn-radio="'{{ option.value }}'"
               ng-bind="option.name"
               ng-required="oqsQuestionControl.isFormElementRequired()"
               name="{{ oqsQuestionControl.question.definition.name + '_' + oqsQuestionControl.question.sectionInstanceId }}"
          ></label>
      </div>
    </div>

    <div ng-switch-when="DROPDOWN"
         class="form-control-container">
      <select class="form-control" ng-model="oqsQuestionControl.question.answer"
              ng-options="option.value as option.name for option in oqsQuestionControl.question.optionList"
              ng-required="oqsQuestionControl.isFormElementRequired()"></select>
    </div>
    <div ng-if="oqsQuestionControl.validationActive" ng-messages="oqsQuestionControlForm.oqsField.$error" role="alert"
         class="oqs-validation-messages">
      <div ng-if="oqsQuestionControl.question.definition.attributes['required-message']" ng-message="required" class="oqs-validation-message">{{oqsQuestionControl.question.definition.attributes['required-message']}}</div>
      <div ng-if="oqsQuestionControl.question.definition.attributes['pattern-message']" ng-message="pattern" class="oqs-validation-message">{{oqsQuestionControl.question.definition.attributes['pattern-message']}}</div>
    </div>
  </div>
</div>
